<template>
  <div id="withdrawalRequest">
    <Form
      :model="form"
      :rules="rules"
      v-model="regular"
    >
      <!-- <Input
        class="temr"
        label="企业名称"
        :readonly="true"
        v-model="form.corpName"
        :labelWidth="labelWidth"
      /> -->
      <van-cell-group class="temr" inset>
        <van-field
          rows="1"
          autosize
          type="textarea"
          :readonly="true"
          label="企业名称"
          v-model="form.corpName"
          :labelWidth="labelWidth"
        />
      </van-cell-group>
      <Input
        class="temr"
        label="借款人姓名"
        v-model="form.borrowerName"
        :readonly="true"
        :labelWidth="labelWidth"
      />

      <div class="company">
        <DrawAmtInput
          class="temr"
          :placeholder="placeholderDrawAmt"
          v-model="form.drawAmt"
          :reg="rules.drawAmt"
          :labelWidth="labelWidth"
          :ispayLimit="isselfPaymentLimit"
          label="支用金额"
          :readonly="isManyiDisabled"
        />
        <span>元</span>
      </div>

      <SelfSelect
        label="支用期限"
        placeholder="请选择支用期限"
        v-model="form.term"
        :columnsTerm="loanTermMap"
        :labelWidth="labelWidth"
        :disabled="isManyiDisabled"
        :defaultValue="form.term"
      />
      <SelfSelect
        label="支付方式"
        placeholder="请选择支付方式"
        v-model="form.payment"
        :columnsTerm="paymentMap"
        :defaultValue="form.payment"
        :labelWidth="labelWidth"
        :disabled="paymentDisabled"
      />
      <div
        v-if="form.payment === '0'"
        class="company"
      >
        <Input
          class="temr"
          label="自主支付限额"
          v-model="form.selfPaymentLimit"
          :readonly="true"
          :labelWidth="labelWidth"
        />
        <span>元</span>
      </div>
      <div v-else>
        <AccountSelect
          label="放款账户名称"
          placeholder="请选择受托支付对象账户名称"
          v-model="form.custName"
          :getSelect="getSelect"
          :columnsTerm="custNameList"
          :labelWidth="labelWidth"
          :orderId="commonForms.orderId"
          :disabled="isManyiDisabled"
        />
      </div>
      <div v-if="showAccountDetails">
        <div class="company">
          <Input
            class="temr"
            label="受托支付对象限额"
            v-model="form.custPaymentLimit"
            :readonly="true"
            :labelWidth="labelWidth"
          />
          <span>元</span>
        </div>
        <Input
          class="temr"
          label="放款账号"
          maxlength="32"
          placeholder="请输入放款账号"
          v-model="form.loanBankNo"
          :labelWidth="labelWidth"
          :readonly="isManyiDisabled"
        />
        <Input
          class="temr"
          label="开户网点名称"
          maxlength="100"
          type="text"
          placeholder="请输入开户网点名称"
          v-model="form.loanBankName"
          :blur="loanBankNameFocusHandler"
          :labelWidth="labelWidth"
          :readonly="isManyiDisabled"
        />
        <Input
          class="temr"
          label="开户行行名"
          placeholder="请输入开户行行名"
          v-model="form.openBankName"
          maxlength="50"
          :labelWidth="labelWidth"
          :readonly="isManyiDisabled"
        />
        <Input
          class="temr"
          label="开户行行号"
          placeholder="请输入开户行行号"
          v-model="form.openBankNo"
          maxlength="20"
          :labelWidth="labelWidth"
          :readonly="isManyiDisabled"
        />
        <Input
          class="temr"
          label="现代支付号"
          placeholder="请输入现代支付号"
          v-model="form.openBankNo"
          :readonly="true"
          :labelWidth="labelWidth"
        />
        <div>
          <!-- <Input
            class="temr"
            label="放款附言"
            placeholder="请输入放款附言"
            v-model="form.postscript"
            maxlength="40"
            :labelWidth="labelWidth"
          /> -->
          <van-cell-group inset>
            <van-field
              rows="1"
              autosize
              type="textarea"
              placeholder="请输入放款附言"
              class="temr"
              label="放款附言"
              v-model="form.postscript"
              maxlength="20"
              :labelWidth="labelWidth"
              :readonly="isManyiDisabled"
            />
          </van-cell-group>
          <p class="alertRed">重要提示：请提前与收款人就放款附言达成一致，便于收款人识别资金来源，避免收款人无法核实入账</p>
        </div>
      </div>
      <SelfSelect
        label="还款方式"
        placeholder="请选择还款方式"
        v-model="form.rtnTypes"
        :columnsTerm="columnsTermMethod"
        :labelWidth="labelWidth"
      />
      <Input
        class="temr"
        label="银行卡号"
        v-model="form.repayCardNo"
        :readonly="true"
        :labelWidth="labelWidth"
      />
      <Input
        class="temr"
        label="银行"
        v-model="form.bankName"
        :readonly="true"
        :labelWidth="labelWidth"
      />
      <Input
        class="temr"
        label="银行预留手机号"
        v-model="form.borrowerPhone"
        :readonly="true"
        :labelWidth="labelWidth"
      />
      <OwnMessageCode
        v-model="form.captcha"
        :reg="rules.captcha"
        label="短信验证码"
        :params="{
          phone: form.borrowerPhone,
          type: '5'
        }"
        :labelWidth="labelWidth"
      />
      <!-- <Contract
        :list="contractList"
        v-model="agreeState"
        :defaultCheck="false"
      /> -->
    </Form>
    <SelfButton
      :loading="loading"
      loadingText="提交中..."
      :text="draw"
      :type="danger"
      :disabled="!isDisabled"
      class="nextStep"
      :click="goToNextPage"
    />
    <server-bank
      :productId="this.$route.query.productId"
      :isRelative=true
    ></server-bank>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import { milliFormat } from '@/utils';
import ServerBank from '@/components/ServerBank.vue';
import DrawAmtInput from './components/DrawAmtInput.vue';
import AccountSelect from './components/AccountSelect.vue';
import OwnMessageCode from './components/MessageCode.vue';
import Contract from '@/components/Contract.vue';

export default {
  name: 'withdrawalRequest',
  components: {
    DrawAmtInput,
    AccountSelect,
    OwnMessageCode,
    ServerBank,
    Contract,
  },
  data() {
    return {
      agreeState: true,
      contractList: [
        {
          text: '个人信息查询和提供在线授权书 ',
          value: 'spdb_pi',
        },
        {
          text: '用途声明书 ',
          value: 'spdb_uspec',
        },
      ],
      labelWidth: '129px',
      danger: 'danger',
      draw: '提交',
      columnsTermMethod: [
        {
          text: '等额本息',
          value: '01',
        },
      ],
      loanTermMap: [
        { text: '3个月', value: '3' },
        { text: '6个月', value: '6' },
        { text: '12个月', value: '12' },
      ],
      paymentMap: [
        { text: '自主支付', value: '0' },
        { text: '受托支付', value: '1' },
      ],
      loading: false,
      setInterval: null,
      form: {
        corpName: '',
        borrowerName: '',
        drawAmt: '',
        term: '',
        payment: '0',
        rtnTypes: '',
        repayCardNo: '',
        bankName: '浦发银行',
        borrowerPhone: '',
        captcha: '',
        selfPaymentLimit: '',
        selfPaymentLimitNumber: '',
        custName: '',
        custPaymentLimit: '',
        custPaymentLimitNumber: '',
        loanBankNo: '',
        loanBankName: '',
        openBankName: '',
        openBankNo: '',
        postscript: '',
      },
      usableAmount: '',
      taxNo: '',
      regular: false,
      rules: {
        term: [{ required: true }],
        payment: [{ required: true }],
        rtnTypes: [{ required: true }],
        drawAmt: [
          {
            pattern: /^[1-9]\d{0,}$/,
            message: '支用金额格式输入有误,只能输入不以0开头的整数',
          },
        ],
        captcha: [{ pattern: /^\d{6}$/, message: '请输入6位数字的验证码' }],
      },
      showAccountDetails: false,
      // 账户名数组
      custNameList: [],
      isManyiDisabled: false, // 优企贷-满意物流 禁用
      paymentDisabled: false // 建发
    };
  },
  computed: {
    ...mapState({
      commonForms(val) {
        return val.commonForms;
      },
    }),
    isselfPaymentLimit() {
      const {
        payment,
        selfPaymentLimitNumber,
        custPaymentLimitNumber,
        drawAmt,
      } = this.form;
      let payLimit = selfPaymentLimitNumber;
      let payLimitText = '自主支付';
      if (payment === '1') {
        payLimit = custPaymentLimitNumber;
        payLimitText = '受托支付';
      }
      return {
        payment,
        payLimit,
        drawAmt,
        payLimitText,
      };
    },
    isDisabled() {
      const {
        payment,
        loanBankNo,
        loanBankName,
        openBankName,
        openBankNo,
        drawAmt,
        selfPaymentLimitNumber,
        custPaymentLimitNumber,
        postscript,
      } = this.form;
      if (payment === '1') {
        if (this.regular
          && loanBankNo
          && loanBankName
          && openBankName
          && openBankNo
          && postscript
        ) {
          if (parseInt(drawAmt || 0, 10) > parseInt(custPaymentLimitNumber, 10)) {
            return false;
          }
          return true;
        }
        return false;
      }
      if (parseInt(drawAmt || 0, 10) > parseInt(selfPaymentLimitNumber, 10)) {
        return false;
      }
      if (!this.agreeState) {
        return false;
      }
      return this.regular;
    },
    placeholderDrawAmt() {
      return `剩余可提款额${this.usableAmount}元`;
    },
  },
  mounted() {
    // this.form.selfPaymentLimit = `剩余可用${milliFormat('500000', 1)}`;
    this.getSpdbRepayTerm();
    this.updateForm({
      captchaType: '5',
    });
    this.getDrawerInfo();
    this.loadPayment('0')
  },
  watch: {
    'form.payment': {
      handler(val) {
        if (val === '0') {
          this.showAccountDetails = false;
          this.loadPayment(val);
        } else if (val === '1') {
          this.loadPayment(val);
        }
      },
    },
    'form.custName': {
      handler(val) {
        if (val) {
          this.showAccountDetails = true;
        }
      },
    },
  },
  methods: {
    ...mapMutations('commonForms', ['updateForm']),
    goToNextPage() {
      this.spdbDrawApply();
    },
    // 提款申请
    spdbDrawApply() {
      const {
        orderId,
      } = this.commonForms;
      const {
        borrowerPhone,
        captcha,
        drawAmt,
        bankName,
        term,
        captchaType = '5',
        rtnTypes,
        selfPaymentLimitNumber,
        payment,
        custPaymentLimitNumber,
        custName, // 放款账户户名 （受托支付必填）
        loanBankName, // 开户网点名称（受托支付必填）
        loanBankNo, // 放款账号（受托支付必填）
        openBankName, // 开户行行名（受托支付必填）
        openBankNo, // 开户行行号（受托支付必填）
        postscript, // 放款附言（受托支付必填）
      } = this.form;
      const localParams = payment !== '0' ? {
        custName, // 放款账户户名 （受托支付必填）
        loanBankName, // 开户网点名称（受托支付必填）
        loanBankNo, // 放款账号（受托支付必填）
        openBankName, // 开户行行名（受托支付必填）
        openBankNo, // 开户行行号（受托支付必填）
        paymentNo: openBankNo, // 现代支付号（受托支付必填）
        postscript, // 放款附言（受托支付必填）
      } : {};
      if (drawAmt * 1 <= this.usableAmount * 1) {
        this.$loading.show('提交中...');
        this.onLoaderSaving = true;
        let api = '';
        if (this.$route.query.productId === 'SPDB-FPD') {
          api = this.$api.CommonForms.spdbDrawApply;
        } else {
          api = this.$api.CommonForms.spdbYQDDrawApply;
        }
        const data = api({
          orderId,
          bankPhone: borrowerPhone,
          captcha,
          drawAmt,
          bankName,
          rtnTypes,
          term,
          captchaType,
          paymentType: payment,
          paymentLimit: payment === '0' ? selfPaymentLimitNumber : custPaymentLimitNumber,
          ...localParams,
        });
        data
          .then((res) => {
            this.$loading.hide();
            console.log(res, '==res');
            if (res.success) {
              this.jumpCurrPage();
            } else {
              // 这几个错误码时不要跳转页面 其他报错都跳转页面
              const code = ['10035', '10036', '10037', '10038', '10039', '10040', '10041'];
              this.$toast(res.returnMessage);
              if (!code.includes(res.returnCode)) {
                window.setTimeout(() => {
                  this.jumpCurrPage();
                }, 2000);
              }
            }
          })
          .catch(() => {
            this.onLoaderSaving = false;
            this.$toast('小望已离开地球，请稍后重试！');
          });
      } else {
        this.$toast('输入金额不能大于可提款金额');
      }
    },
    // 后端进行跳转
    jumpCurrPage() {
      const { orderId } = this.commonForms;
      this.$api.PublicPage.jumpCurrPage({
        orderId: orderId || localStorage.getItem('orderId'),
      })
        .then((res) => {
          if (res.success) {
            if (res.data) {
              window.location.href = res.data;
            }
          } else {
            this.$dialog.alert({
              title: '提示',
              message: '操作失败',
            });
          }
        })
        .catch((e) => {
          this.$dialog.alert({
            title: '提示',
            message: e,
          });
        });
    },
    // 选中账户名字
    getSelect(val) {
      this.showAccountDetails = true;
      this.form = {
        ...this.form,
        ...val,
        custName: val.cust_name,
        custPaymentLimit: `剩余可用${milliFormat(val.custPaymentLimit, 1)}`,
      };
      this.form.custPaymentLimitNumber = val.custPaymentLimit;
    },


    // 提款申请
    async getDrawerInfo() {
      const { orderId } = this.commonForms;

      if (this.$route.query.productId === 'SPDB-FPD') {
        this.$api.CommonForms.getSpdbApplyDrawInfo({orderId}).then((res) => {
          if (res.success) {
            this.usableAmount = res.data.usableAmount;
            this.taxNo = res.data.taxNo;
            this.form = {
              ...this.form,
              ...res.data,
            };
          }
        })
        .catch((error) => {
          console.log('error:', error)
          this.$toast('小望已离开地球，请稍后重试！');
        });
      }


      if (this.$route.query.productId === 'SPDB-YQD') {
        try {
          this.$api.CommonForms.getSYqdApplyDrawInfo({orderId}).then((info) => {
            console.log(info.data, '==data')
            // sendType 1满易 2建发
            // editAble:false禁用  true可编辑

            // 1满易
            const { editAble,  sendType} = info.data
            if (!editAble && sendType === 1) { 
              this.isManyiDisabled = true
              this.showAccountDetails = true
              this.paymentDisabled = true // 支付方式是否禁用
              this.form = {
                ...this.form,
                ...info.data,
                payment: '1',
                term: info.data.term + '',
                drawAmt: Number(info.data.loanAmount),
              }
              // 当字段值为false时，会影响组件校验
              delete this.form.editAble
            }

            // 2建发
            if (!editAble && sendType === 2) {
              this.paymentDisabled = true // 支付方式是否禁用
              this.form.payment = '1' // 支付方式
            }

            this.$api.CommonForms.getSpdbYQDApplyDrawInfo({
              orderId,
            }).then((res) => {
              if (res.success) {
                this.usableAmount = res.data.usableAmount;
                this.taxNo = res.data.taxNo;
                this.form = {
                  ...this.form,
                  ...res.data,
                };
              }
            })
          })
        } catch(error) {
          console.log(error)
          this.$toast('小望已离开地球，请稍后重试！');
        }
      }

    },

    // 默认显示自主支付
    async loadPayment(type) {
      const { orderId } = this.commonForms;
      let api = '';
      if (this.$route.query.productId === 'SPDB-FPD') {
        api = this.$api.OtherPage.getPayment;
      } else {
        api = this.$api.OtherPage.getSpdbYQDPayment;
      }
      const res = await api({
        orderId,
        type,
      });
      if (this.form.payment === '0') {
        this.form.selfPaymentLimit = `剩余可用${milliFormat(res.data.selfPaymentLimit || 0, 1)}`;
        this.form.selfPaymentLimitNumber = res.data.selfPaymentLimit;
      } else {
        this.custNameList = res.data.list;
      }
    },
    // 后端控制页面跳转
    nextJumpPage() {
      const { orderId } = this.commonForms;
      this.$api.CommonForms.nextJumpPageServer({
        orderId: orderId || localStorage.getItem('orderId'),
      }).then((res) => {
        if (res.success) {
          if (res.data) {
            window.location.href = res.data;
          }
        }
        this.$loading.hide();
      });
    },

    // 获取支用期限
    getSpdbRepayTerm() {
      const { orderId } = this.commonForms;

      let api = '';
      if (this.$route.query.productId === 'SPDB-FPD') {
        api = this.$api.PublicPage.getSpdbRepayTerm;
      } else {
        api = this.$api.PublicPage.getYQDSpdbRepayTerm;
      }


      api({ orderId }).then((res) => {
        if (res.returnCode === '200' && res.data) {
          this.loanTermMap = res.data;
        } else {
          this.$toast(res.returnMessage);
        }
      });
    },
    async loanBankNameFocusHandler() {
      if (this.form.loanBankName === '') return;
      const res = await this.$api.OtherPage.getBankInfo({
        loanBankName: this.form.loanBankName,
      });
      if (res.success) {
        this.form = {
          ...this.form,
          ...res.data,
        };
      } else {
        this.$toast(res.returnMessage);
      }
    },
  },
};
</script>
<style scoped>
#withdrawalRequest {
  width: 100%;
  height: 100%;
  background: #fff;
}
#withdrawalRequest >>> .van-field__label {
  width: 129px;
  margin-right: 0;
  color: #1c2438;
}
.temr::after {
  position: absolute;
  right: 16px;
  top: auto;
  bottom: 0;
  left: 16px;
  box-sizing: border-box;
  border-bottom: 1px solid #dddee1 !important;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  content: " ";
  pointer-events: none;
}
.mt8 {
  padding-top: 8px;
}
.nextStep {
  margin-top: 30px;
  margin-bottom: 12px;
}
.getCode {
  color: rgba(246, 82, 73, 1);
  font-weight: 400;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
}
.code_btn {
  position: absolute;
  right: 14px;
  bottom: 7px;
  z-index: 3;
  width: auto;
  height: 35px;
  background: #fff;
  border: none;
}
.company {
  position: relative;
}
.company > span {
  position: absolute;
  top: 12px;
  right: 16px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #1c2438;
}
.company >>> .cross {
  margin-right: 38px;
}
.paymentChange {
  /* white-space: wrap;
  overflow: scroll; */
  /* display: block; */
  word-wrap: break-word;
  word-break: break-all;
}
.alertRed {
  width: 380px;
  font-size: 12px;
  color: red;
  margin-left: 15px;
  margin-top: -2px;
  margin-bottom: -2px;
  text-align: left;
}
</style>
